import React from 'react'
import Panel from '../panels/Panel'
import PanelButton from '../panels/PanelButton'
import InfoPanel from '../panels/InfoPanel'
import Disclaimer from '../panels/Disclaimer'

const PlayShareDialog = ({ topic, onSharePlaylistPlay, type="custom_share" }) => {
  const shareHeader = (type === "custom_share") ? <p className='font-bold text-center text-lg'>Can you beat your friend&apos;s Trivia Playlist?</p> : null
  return (
    <div className={'flex flex-col flex-grow items-center w-[100%] max-w-[1040px] min-w-[360px]'}>
      <div className={'flex flex-col flex-grow items-center w-[100%] max-w-[1040px] min-w-[360px] gap-6 p-8'}>
        <Panel>
          <div className='flex text-black flex-col gap-4 p-4'>
            { shareHeader }
            <p className='font-bold text-2xl text-center uppercase'>{topic}</p>
            <div className='pl-4'>
              
              <ul className='list list-disc'>
                <li className="font-gReg text-base">The playlist has 6 trivia questions.</li>
                <li className="font-gReg text-base">You have 30 seconds to answer each one.</li>
                <li className="font-gReg text-base">Tap on the correct answer to earn a wedge.</li>
                <li className="font-gReg text-base">Share your score with your friends, offer a rematch, & more!</li>
              </ul>
            </div>
          </div>
        </Panel>
        <PanelButton type={'play'} onClick={onSharePlaylistPlay} />
        <InfoPanel />
      </div>
      <Disclaimer />
    </div>
  )
}

export default PlayShareDialog